import type { PageType } from '@/types/models'
import { isLocationPageType } from './pageTypeCheck'
import { isNumber } from '@/utils/checks'
type MiniCardType = {
  img: string
  count: number
  title: string
  location?: string
  isUnitedStatesCount: boolean
  insuranceSlug?: string
  anchorTitle: string
}

export const shouldUseAnchorTag = ({
  card,
  pageType,
  cardCountLimit,
  forceAnchorTag = false
}: {
  card: MiniCardType
  pageType: PageType
  cardCountLimit: number
  forceAnchorTag?: boolean
}): boolean => {
  return (
    forceAnchorTag ||
    (isNumber(card.count) &&
      card.count > cardCountLimit &&
      isLocationPageType(pageType))
  )
}
